import { render } from "./ModalManagerEventselection.vue?vue&type=template&id=a0a30054"
import script from "./ModalManagerEventselection.vue?vue&type=script&lang=js"
export * from "./ModalManagerEventselection.vue?vue&type=script&lang=js"

import exportComponent from "/media/dev/Develop/Projects/Sjef/kiosk.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__